var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFinal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "       M 0 0       H 60       L 30 25       L 0 0       M 0 0       V 50     ",
    stroke: "#2D3748",
    strokeWidth: 4.5,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 12,
    r: 3,
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 25,
    r: 3,
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 38,
    r: 3,
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 50,
    r: 3,
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "         M 0 12         L 18 25         L 30 38         M 18 25         L 18 50       ",
    stroke: "#2D3748",
    strokeWidth: 2,
    opacity: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFinal);
export default __webpack_public_path__ + "static/media/logo-final.a2b1c80e80e0dd620c2102e4df90034d.svg";
export { ForwardRef as ReactComponent };